export default "__VITE_ASSET__fe124b91__"